<template>
        <span @click="toggleFollow" class="notification-bell"><img :src="'../../images/icons/' + bell_icon"></span>

</template>

<script>
    import axios from 'axios'

    export default {

        props: ['endpoint', 'fixture_id', 'following'],

        data() {

            return {
                bell_icon : 'alert-off.svg',
                method: 'POST',
                is_following: this.following
            }

        },

        methods: {

            toggleFollow() {
                if (this.is_following) {

                    axios.delete(this.endpoint + '/' + this.fixture_id, {
                    }).then((response) => {
                        this.message = 'Preference updated';
                        this.bell_icon = 'alert-off.svg';
                        this.is_following = !this.is_following;
                    }).catch((response) => {
                        this.message = 'Preference could not be updated';
                    });

                } else {

                    axios.post(this.endpoint, {
                        fixtureId : this.fixture_id
                    }).then((response) => {
                        this.message = 'Preference updated';
                        this.bell_icon = 'alert-on.svg';
                        this.is_following = !this.is_following;
                    }).catch((response) => {
                        this.message = 'Preference could not be updated';
                    });

                }

            }

        },

        mounted() {
            if (this.following) {
                this.bell_icon = 'alert-on.svg';

            } else {
                this.bell_icon = 'alert-off.svg';

            }
            this.is_following = this.following;
        }

    }
</script>
